module.exports = __webpack_public_path__ + "img/badge-4k.c48d7bbf.svg";